import {HStack, Text} from 'platform/foundation';
import styled from 'styled-components';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {WEIGHT_SCALE} from '../constants/WEIGHT_SCALE';

const DOT_SIZE = '0.875rem';

const DotButton = styled.button<{$isFilled: boolean}>`
  width: ${DOT_SIZE};
  height: ${DOT_SIZE};
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid
    ${({theme, $isFilled}) =>
      $isFilled ? theme.colors.palettes.blue[60][100] : theme.colors.palettes.neutral[50][100]};
  background-color: ${({theme, $isFilled}) =>
    $isFilled ? theme.colors.palettes.blue[60][100] : 'transparent'};
  transition:
    transform 150ms,
    border-color 150ms;

  &:hover {
    transform: scale(1.15);
    border-color: ${({theme}) => theme.colors.palettes.blue[60][100]};
  }
`;

export interface WeightDotsControlProps extends TestIdProps {
  value: number;
  onChange: (weight: number) => void;
}

// Matches the audit runtime's "WEIGHT ●○○○○ 1" glyph. Weight is 1–5 by domain
// rule — this control physically cannot produce anything else.
export function WeightDotsControl(props: WeightDotsControlProps) {
  return (
    <HStack spacing={2} align="center">
      <HStack spacing={1} align="center">
        {WEIGHT_SCALE.map((dot) => (
          <DotButton
            key={dot}
            type="button"
            $isFilled={dot <= props.value}
            onClick={() => props.onChange(dot)}
            aria-label={i18n.t('entity.recordAudit.task.weightValue', {weight: dot})}
            data-testid={suffixTestId(`weightDot-${dot}`, props)}
          />
        ))}
      </HStack>
      <Text size="small" alternative>
        {props.value.toString()}
      </Text>
    </HStack>
  );
}
